export default function CardsSection() {
  const cards = [
    {
      id: 1,
      title: '斗罗大陆动画全系列',
      desc: '唐三的成长史诗，从圣魂村到神界的传奇旅程。51动漫网站完整收录全部剧集。',
      tag: '玄幻巅峰',
      image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20anime%20scene%20with%20a%20young%20warrior%20wielding%20glowing%20weapon%2C%20mystical%20forest%20background%2C%20warm%20golden%20light%20rays%2C%20dramatic%20atmosphere%2C%20vibrant%20red%20and%20amber%20color%20palette%2C%20clean%20anime%20art%20style&width=600&height=400&seq=card-1-anime&orientation=landscape',
    },
    {
      id: 2,
      title: '紫川·光明王传说',
      desc: '紫川秀的权谋与热血，史诗级战争场面震撼呈现。51动漫国产精品入口推荐。',
      tag: '权谋史诗',
      image: 'https://readdy.ai/api/search-image?query=Medieval%20fantasy%20anime%20scene%20with%20knights%20and%20battlefield%2C%20dramatic%20sunset%20sky%2C%20warm%20orange%20and%20crimson%20tones%2C%20epic%20scale%2C%20detailed%20armor%20designs%2C%20cinematic%20composition%2C%20anime%20art%20style&width=600&height=400&seq=card-2-anime&orientation=landscape',
    },
    {
      id: 3,
      title: '三体动画：黑暗森林',
      desc: '刘慈欣科幻巨制动画化续作，宇宙社会学揭示宇宙文明残酷真相。',
      tag: '科幻巨制',
      image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20anime%20scene%20with%20spaceships%20and%20stars%2C%20dark%20space%20with%20warm%20nebula%20glow%2C%20cosmic%20scale%2C%20dramatic%20lighting%2C%20red%20and%20amber%20accents%2C%20clean%20modern%20anime%20style&width=600&height=400&seq=card-3-anime&orientation=landscape',
    },
    {
      id: 4,
      title: '元龙·逆天改命',
      desc: '王胜穿越异界，用现代知识逆天改命。51动漫网热血推荐国产动画佳作。',
      tag: '穿越热血',
      image: 'https://readdy.ai/api/search-image?query=Isekai%20fantasy%20anime%20scene%20with%20a%20modern%20character%20in%20ancient%20world%2C%20magical%20elements%2C%20dragon%20silhouette%2C%20warm%20sunset%20lighting%2C%20adventure%20atmosphere%2C%20vibrant%20colors%2C%20anime%20art%20style&width=600&height=400&seq=card-4-anime&orientation=landscape',
    },
    {
      id: 5,
      title: '灵笼：废土求生',
      desc: '末日废土世界观，人类最后的城市灯塔。画面与音乐均为国产动画顶级水准。',
      tag: '末日科幻',
      image: 'https://readdy.ai/api/search-image?query=Post-apocalyptic%20anime%20scene%20with%20ruins%20and%20survivors%2C%20warm%20sunset%20light%20through%20broken%20structures%2C%20dramatic%20atmosphere%2C%20orange%20and%20amber%20tones%2C%20detailed%20environment%2C%20anime%20art%20style&width=600&height=400&seq=card-5-anime&orientation=landscape',
    },
    {
      id: 6,
      title: '少年歌行·海外仙山篇',
      desc: '雷无桀与萧瑟的江湖奇旅，飘逸画风与热血剧情完美结合。51动漫主页推荐。',
      tag: '武侠江湖',
      image: 'https://readdy.ai/api/search-image?query=Wuxia%20anime%20scene%20with%20two%20swordsmen%20on%20mountain%20peak%2C%20flowing%20robes%2C%20misty%20mountains%2C%20warm%20golden%20hour%20lighting%2C%20elegant%20Chinese%20painting%20aesthetic%2C%20anime%20art%20style&width=600&height=400&seq=card-6-anime&orientation=landscape',
    },
    {
      id: 7,
      title: '天官赐福·第二季',
      desc: '花城与谢怜的神界爱情故事续篇，精致画风和细腻情感席卷全网动漫爱好者。',
      tag: '古风玄幻',
      image: 'https://readdy.ai/api/search-image?query=Romantic%20fantasy%20anime%20scene%20with%20two%20elegant%20characters%2C%20cherry%20blossoms%2C%20ancient%20Chinese%20palace%20background%2C%20soft%20warm%20lighting%2C%20delicate%20art%20style%2C%20pink%20and%20amber%20tones%2C%20beautiful%20composition&width=600&height=400&seq=card-7-anime&orientation=landscape',
    },
  ];

  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            动漫推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            51动漫精选高分国产动漫，覆盖多元题材，总有一部适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {cards.slice(0, 4).map((card) => (
            <a
              key={card.id}
              href="#cards"
              className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-[180px] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={`51动漫推荐 - ${card.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-full">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base text-foreground-950 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mt-5 md:mt-6">
          {cards.slice(4).map((card) => (
            <a
              key={card.id}
              href="#cards"
              className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-[200px] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={`51动漫推荐 - ${card.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-full">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base text-foreground-950 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}